module.exports = __webpack_public_path__ + "img/logo6.e4c5c921.png";